import { useState, useEffect, useCallback } from 'react';
import { sponsorService, SponsorCompany } from '../services/sponsorService';
import { useToast } from './useToast';

export interface UseSponsorCompaniesReturn {
  companies: SponsorCompany[];
  loading: boolean;
  error: string | null;
  refetch: () => Promise<void>;
}

/**
 * スポンサー企業一覧取得hook（学生向け）
 */
export const useSponsorCompanies = (): UseSponsorCompaniesReturn => {
  const [companies, setCompanies] = useState<SponsorCompany[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const { showToast } = useToast();

  const fetchCompanies = useCallback(async () => {
    setLoading(true);
    setError(null);

    try {
      const response = await sponsorService.getSponsorCompanies();
      setCompanies(response.data.companies);
    } catch (err) {
      const errorMessage =
        err instanceof Error
          ? err.message
          : 'スポンサー企業の取得に失敗しました';
      setError(errorMessage);
      // 学生向けなので、エラーはコンソールに出力するだけでトーストは表示しない
      console.error('スポンサー企業取得エラー:', errorMessage);
    } finally {
      setLoading(false);
    }
  }, []);

  const refetch = useCallback(async () => {
    await fetchCompanies();
  }, [fetchCompanies]);

  // 初期データ取得
  useEffect(() => {
    fetchCompanies();
  }, [fetchCompanies]);

  return {
    companies,
    loading,
    error,
    refetch,
  };
};
